export const getSlug = (canonicalURL: string, url: string) => {
  const BASE_URL = '/community/narratives';

  if (!canonicalURL) {
    return `${BASE_URL}`;
  }

  const companyCanonicalUrl = String(canonicalURL).split('/');

  const segments = [
    '',
    'community',
    'narratives',
    ...companyCanonicalUrl.slice(2),
    url.split('/').pop(),
  ];

  return segments.join('/');
};
